import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueMeta from 'vue-meta'

import * as subscriptionStore from './components/common/subscriptionStore'
import * as helpers from './utils/helpers'

Vue.use(VueMeta, {
    // optional pluginOptions
    refreshOnceOnNavigation: true
})

window.domain = 'https://stats.curve.finance'
//if(window.location.href.includes('localhost') || !window.location.href.includes('curve.finance')) window.domain = 'https://www.curve.finance'

import '../public/tvisionbase.css'
import '../public/tvision.css'
import './registerServiceWorker'

subscriptionStore.init();

Vue.config.productionTip = false

let ignoreErrors = [
    /.*ObjectMultiplex.*/gm,
    /.*Invalid JSON RPC.*/gm,
    /.*MaxListenersExceededWarning.*/gm,
    /.*Heads up!.*/gm,
    /.*invalid number value.*/gm,
    /.*Out of Gas.*/gm,
    /.*invalid address.*/gm,
    /.*property '_address' of undefined.*/gm,
    /.*TypeError: Cannot read property 'chart' of undefined.*/gm,
    /.*Cannot read property '0' of undefined.*/gm,
    /.*Non-Error promise rejection captured with keys.*/gm,
]

new Vue({
    router,
    render: h => h(App)
}).$mount('#app')
